import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { optimizeImageUrl } from "@/lib/imageUtils";
import PageBanner from "@/components/PageBanner";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((res) => setPosts(res.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-list-page" className="min-h-[70vh] bg-[#FDFCFB]">
      <PageBanner pageKey="blog" eyebrow="Insights" title="Blog &amp; Press Releases" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 pt-10 sm:pt-0">
        <p data-testid="blog-seo-intro" className="text-center text-sm text-[var(--brand-secondary)] max-w-3xl mx-auto mb-8 leading-relaxed">
          Practical guides and the latest updates on GAMCA medical appointments, WAFID slip recovery, Gulf visa rules, Umrah travel and working in the GCC - written by the Gulfudaan team to help you avoid common mistakes and save money.
        </p>
        {loading ? (
          <div className="flex justify-center"><Loader2 className="animate-spin text-[var(--brand-primary)]" size={28} /></div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
                className="rounded-lg border border-[#E5E1DA] bg-white overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <img src={optimizeImageUrl(p.image, 500)} alt={p.title} loading="lazy" className="w-full h-48 object-cover" />
                <div className="p-6">
                  <h3 className="font-heading text-xl text-[#1A1A1A] mb-2 line-clamp-2">{p.title}</h3>
                  <p className="text-sm text-[var(--brand-secondary)] line-clamp-3 mb-4">{p.excerpt}</p>
                  <span className="text-[var(--brand-primary)] text-sm font-medium flex items-center gap-1">Read More <ArrowRight size={14} /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
